import { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom"
import { Link } from "react-router-dom";
// services
import * as webBridgeService from '../../../services/webBridgeService'
import * as tokenService from '../../../services/tokenService'
// styles
import styles from "./LeadCaptureSelect.module.css"
// ------ Components ------ //
import { AsyncPaginate } from 'react-select-async-paginate';
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"

const LeadCaptureSelect = () => {
    const navigate = useNavigate()
    const [loaded, setLoaded] = useState(false);
    const [initEntries, setInitEntries] = useState([]);
    const [selectedOption, setSelectedOption] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(15);
    const [user, setUser] = useState(null);
    const createSearchBody = async (searchQuery) => {
        let requestBody = {}
        requestBody =
        {
            "searchValue": `${searchQuery}`,
            "index": `${currentPage}`,
            "pageSize": `${itemsPerPage}`,
            "futureOnly": true,
            "includeTests": false,
        }

        return await requestBody;
    }
    const isFormValid = () => {
        return selectedOption && selectedOption.refNumber
            ? true
            : false
    }
    const handleSubmit = async e => {
        e.preventDefault()
        navigate('/LeadCaptureOrder/' + selectedOption.refNumber);
    }
    const onInputChange = entry => {
        // triggered when typing changes
        if (entry !== searchQuery) {
            // reset pages
            setCurrentPage(1)
        }
    };
    const onChange = option => {
        // triggered when option selected
        // navigate to edit screen? or need to press continue to move forward
        // have to get all entries for the option
        setSelectedOption(option);
    };
    const loadOptions = async (newSearchQuery) => {
        // returns list of AttendeeBadge (small)
        let eventSearchItems = [];
        if (currentPage === 1 && newSearchQuery === '' && initEntries && initEntries.length > 0) {
            eventSearchItems = initEntries;
        }
        else {
            eventSearchItems = await webBridgeService.fetchLeadCapturesPaged(await createSearchBody(newSearchQuery));
        }
        eventSearchItems.forEach((item) => {
            // has to have value and label defined
            item.value = item.refNumber;
            item.label = item.overwriteName + ' (' + item.client.clientName + ')';
        })
        setSearchQuery(newSearchQuery)
        setCurrentPage(currentPage + 1)
        return {
            options: eventSearchItems,
            hasMore: eventSearchItems.length >= 1,
            //additional: {
            //    page: searchQuery ? 2 : page + 1,
            //},
        };
        
    };
    const loadInits = async () => {
        // returns list of AttendeeBadge (small)
        const eventSearchItems = await webBridgeService.fetchLeadCapturesPaged(await createSearchBody(searchQuery));
        if (eventSearchItems && eventSearchItems.length) {
            setInitEntries(eventSearchItems);
        }

    };
    const getUser = () => {
        let userInfo = tokenService.getUserFromToken();
        if (userInfo) {
            setUser(userInfo);
        }
        return userInfo;
    }
    useEffect(() => {
        let user = getUser();
        if (user) {
            navigate('/Index');
        }
        loadInits();
        setLoaded(true);
    }, [])
    return (
        <>{!loaded ? <LoadingSpinner /> :
            <>
                <div className="page-area">
                    Please select Lead Capture:<br /><br />
                    <div className={styles.dropdownContainer} title="Search by Lead Capture name or by organizer name.">
                        {initEntries && initEntries.length > 0 ?
                            <>
                                <AsyncPaginate
                                    //value={searchTerm} // don't use with loadOptions, one or other
                                    loadOptions={loadOptions}//activates selections
                                    //getOptionValue={option => option.value}
                                    //getOptionLabel={option => option.label}
                                    defaultOptions
                                    onInputChange={onInputChange} // detects typing entry
                                    onChange={onChange} // option selected
                                    isClearable={true}
                                    isSearchable={true}
                                    placeholder={'Lead Capture Name'}
                                /*additional={{
                                    page: 0,
                                }}*/
                                />
                                <br /><br />
                                Press 'Submit' to begin order process.
                            </>
                            
                            : <div>
                                <div className={styles.errorEventsMessage}> No lead capture events configured!</div> <br /><br />
                            </div>
                        }

                    </div>
                    <button disabled={!isFormValid()} className={styles.button} onClick={handleSubmit}>
                        Submit
                    </button>
                   
                </div><br /><br /><br /><br />
                <Link to='/LeadCaptureList' title="Select from list of all available Lead Captures.">See All Lead Captures</Link>
                <br /><br /><br /><br />     
            </>
            
            }
        </>

      
    );
}
export default LeadCaptureSelect;